export default "__VITE_ASSET__DHyyw_8G__"